__turbopack_context__.v({
  "actions": "KOKgcq_actions",
  "cancel": "KOKgcq_cancel",
  "confirm": "KOKgcq_confirm",
  "icon": "KOKgcq_icon",
  "modal": "KOKgcq_modal",
  "overlay": "KOKgcq_overlay",
});
